import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { EmployeeService } from '@app/services/employee.service';
import { FeatureFlagService } from '@app/services/feature-flag.service';
import { LocalStorageService } from '@app/services/local-storage.service';
import { LocaleService } from '@app/services/locale.service';
import { NavigationService } from '@app/services/navigation.service';
import { SiteService } from '@app/services/site.service';
import { ServiceService } from '@services/service.service';
import { Observable } from 'rxjs/internal/Observable';
import { AddServiceComponent as NewAddServiceComponent } from '../../../../app/components/booking-steps/add-service/add-service.component';

@Component({
    selector: 'app-add-service',
    templateUrl: './add-service.component.html',
    styleUrls: ['./add-service.component.scss'],
    standalone: false,
})
export class AddServiceComponent extends NewAddServiceComponent {
    constructor(
        _router: Router,
        _serviceService: ServiceService,
        _siteService: SiteService,
        _fb: FormBuilder,
        _localStorageService: LocalStorageService,
        public navigationService: NavigationService,
        _featureFlagService: FeatureFlagService,
        _cdRef: ChangeDetectorRef,
        _localeService: LocaleService,
        _employeeService: EmployeeService
    ) {
        super(
            _router,
            _serviceService,
            _siteService,
            _fb,
            _localStorageService,
            _featureFlagService,
            _cdRef,
            _localeService,
            _employeeService
        );
    }

    protected setIsLoading(isLoading: boolean): void {
        this.navigationService.setIsLoading(isLoading);
    }
    protected setIsStepFormValid(isValid: boolean): void {
        this.navigationService.setIsStepFormValid(isValid);
    }
    protected getNavigationButtonChangeObservable(): Observable<string> {
        return this.navigationService.getNavigationButtonName();
    }
}
